<div class="release-notes-list">
  <div class="header">
    <span class="header-text">Historie der Neuerungen:</span>
    <button class="btn btn-white" (click)="add(); releaseNotesAccordion.closeAll()">Aktualisierungen hinzufügen</button>
  </div>
  <mat-accordion [displayMode]="'flat'" #releaseNotesAccordion="matAccordion" [multi]="true">
    <mat-expansion-panel [class.-edit]="data.isEditing" *ngFor="let data of releaseNotes; let i = index; trackBy: trackByRelease">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          {{ data.releaseDate | localDate: 'yMMMdd' : false }}
          &nbsp;<span class="draft">{{ data.publishDate === null ? ' Entwurf' : '' }}</span>

          <span class="fa fa-pencil" aria-hidden="true" (click)="edit(data)"></span>
          <span class="fa fa-trash" aria-hidden="true" (click)="delete(data, i)"></span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul class="notes-list">
        <li *ngFor="let note of data.notesList; trackBy: trackByNotes">
          {{ note }}
        </li>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>
</div>
